export type DraftAttachment = {
    id: string;
    file: File;
    previewUrl?: string;
};

export type ChatScrollSnapshot =
  | { mode: "bottom" }
  | { 
        mode: "anchor"; 
        messageId: string; 
        offsetPx: number;
        fallbackScrollTop: number;
    };
  
export type ChatDraft = {
    text: string;
    attachments: DraftAttachment[];
    scroll?: ChatScrollSnapshot;
    scrollTop?: number;
    activeThreadMessage?: any;
};

export type ThreadDraft = {
    text: string;
    attachments: DraftAttachment[];
    scroll?: ChatScrollSnapshot;
    scrollTop?: ChatScrollSnapshot;
}
  
const drafts = new Map<string, ChatDraft>();

const threadDrafts = new Map<string, ThreadDraft>();
  
export function getThreadDraft(key: string): ThreadDraft | undefined {
    return threadDrafts.get(key);
}
  
export function setThreadDraft(key: string, draft: ThreadDraft) {
    threadDrafts.set(key, draft);
}
  
export function getChatDraft(key: string): ChatDraft | undefined {
    return drafts.get(key);
}
  
export function setChatDraft(key: string, draft: ChatDraft) {
    drafts.set(key, draft);
}
  
export function clearChatDraft(key: string) {
    const d = drafts.get(key);
    d?.attachments.forEach((a) => a.previewUrl && URL.revokeObjectURL(a.previewUrl));
    drafts.delete(key);
}
  